import Vue from 'vue';
export default Vue.extend({
    name: 'PageHeader',
    props: {
        title: {
            type: String,
            required: false
        },
        introduction: {
            type: String,
            required: false
        }
    }
});
